import axios from 'axios';
import Settings from '../../../settings.json';
import {selectDataTypeEnum} from '../../../serverClientShared/sharedEnums';

const url = Settings.isNative ? Settings.frontlineArServer : '';

export class MembersRequester {

    static async getSelectData(workspace, {type, groupId, skip = 0, limit = 50, searchStr = null, projectId = null, excludeAdminsAndOwners = false, eligibleForOwnership = false}) {
        const result = await axios.post(`${url}/MembersManagement/${workspace}/GetMembersAndGroupsForSelection`, {
            type,
            groupId,
            skip,
            limit,
            searchStr,
            projectId,
            excludeAdminsAndOwners,
            eligibleForOwnership,
        });
        return result.data;
    }

    static async getMembersForSelect(workspace, groupId, skip = 0, limit = 50, searchStr = null) {
        return MembersRequester.getSelectData(workspace, {type: selectDataTypeEnum.MEMBERS, groupId, skip, limit, searchStr});
    }

    static async getEligibleOwnersForSelect(workspace, {limit = 200, searchStr = null} = {}) {
        return MembersRequester.getSelectData(workspace, {type: selectDataTypeEnum.MEMBERS, limit, searchStr, eligibleForOwnership: true});
    }

    static async getGroupsForSelect(workspace, skip = 0, limit = 50, searchStr = null) {
        return MembersRequester.getSelectData(workspace, {type: selectDataTypeEnum.GROUPS, skip, limit, searchStr});
    }

    static async getGroupsAndMembersForSelect(workspace, {limit = 200, searchStr = null, projectId = null, excludeAdminsAndOwners = false} = {}) {
        return MembersRequester.getSelectData(workspace, {type: selectDataTypeEnum.BOTH, limit, searchStr, projectId, excludeAdminsAndOwners});
    }

    static async resolveEligibleMemberIds(workspace, excludedRowsIds, query) {
        const result = await axios.post(`${url}/MembersManagement/${workspace}/ResolveEligibleMemberIds`, {excludedRowsIds, query});
        return result.data;
    }

    static async validateEmails(workspace, emails) {
        const result = await axios.post(`${url}/MembersManagement/${workspace}/ValidateEmails`, {emails});
        return result.data;
    }

    static async getAutoReportRecipients(workspace, projectId) {
        const result = await axios.post(`${url}/MembersManagement/${workspace}/${projectId}/GetAutoReportRecipients`);
        return result.data;
    }

    static async inviteMembers(workspace, {emails, roles, groups, accessPayload, rolePresetId}) {
        const result = await axios.post(`${url}/MembersManagement/${workspace}/InviteMembers`, {
            emails,
            roles,
            groups,
            accessPayload,
            rolePresetId,
        });
        return result.data;
    }

    static async resendInvite(workspace, invitedId) {
        const result = await axios.post(`${url}/MembersManagement/${workspace}/ResendInvite`, {invitedId});
        return result.data;
    }

    static async extractEmailsFromFile(workspace, fileText) {
        const result = await axios.post(`${url}/MembersManagement/${workspace}/ExtractEmailsFromFile`, {fileText});
        return result.data;
    }
}
